import React from 'react';
import PropTypes from 'prop-types';
import { EACHWAY_UNAVAILABLE } from '../globalModal/modalMessages'
import './styles.scss';

const EachWay = ({
    id,
    isEachWayEnabled,
    isEachWayChecked,
    onChange,
    setGlobalModal,
    children,
}) => (
         isEachWayEnabled ? (
             <div className="bs-eachWay">
                 { children }
                 <div className="bs-eachWay-toggle">
                     <input
                         id={`bs-betForm-ew-checkbox-${id}`}
                         className="bs-eachWay-input"
                         name="isEachWay"
                         type="checkbox"
                         checked={isEachWayChecked}
                         onChange={onChange}
                     />
                     <label
                         htmlFor={`bs-betForm-ew-checkbox-${id}`}
                         className="bs-eachWay-label"
                     >
                         <span className="bs-eachWay-label-copy">
                         EW
                         </span>
                     </label>
                 </div>
             </div>
         ) : (
             <div className="bs-eachWay">
                 <div className="bs-eachWay-toggle">
                     <button
                         type="button"
                         className="bs-eachWay-toggle--button"
                         onClick={() => {
                             setGlobalModal(EACHWAY_UNAVAILABLE)
                         }}
                     >
                     EW
                     </button>
                 </div>
             </div>
         )
    );

EachWay.defaultProps = {
    children: null,
    isEachWayEnabled: true,
    isEachWayChecked: false,
};

EachWay.propTypes = {
    id: PropTypes.string.isRequired,
    isEachWayEnabled: PropTypes.bool,
    isEachWayChecked: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    setGlobalModal: PropTypes.func.isRequired,
    children: PropTypes.node,
};

export default EachWay;



// WEBPACK FOOTER //
// /src/js/common/eachWay/EachWay.jsx